import { Component, OnInit } from '@angular/core'
import { ChartData, ChartOptions, Chart } from 'chart.js'
import { DashboardAPIService, Tasklist } from '@resultsgate-ui/api'
import { R3BoundTarget } from '@angular/compiler'
@Component({
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
    data: ChartData
    options: ChartOptions
    tasklist: Tasklist
    printCompact = false
    tasklistDateRange: Date[]
    constructor(private api: DashboardAPIService) {
        const draw = Chart.controllers.line.prototype.draw
        // Chart.controllers.line.prototype.draw = function () {
        //     draw.apply(this, arguments)
        //     const ctx = this.chart.chart.ctx
        //     const _stroke = ctx.stroke
        //     ctx.stroke = function () {
        //         ctx.save()
        //         ctx.shadowColor = '#07C'
        //         ctx.shadowBlur = 2
        //         ctx.shadowOffsetX = 0
        //         ctx.shadowOffsetY = 2
        //         _stroke.apply(this, arguments)
        //         ctx.restore()
        //     }
        // }
        this.options = {
            legend: {
                display: false,
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            scales: {
                xAxes: [
                    {
                        type: 'time',
                        time: {
                            unit: 'month',
                            tooltipFormat: 'MMMM YYYY',
                        },
                        ticks: {
                            autoSkip: true,
                            maxRotation: 0,
                        },
                    },
                ],
            },
        }
    }

    ngOnInit(): void {
        this.api.getAdminDashboard({}).subscribe((data) => {
            this.data = {
                labels: data.ordersMonthly.map((i) => new Date(i.date)),
                datasets: [
                    {
                        label: 'Objednávky',
                        data: data.ordersMonthly.map((i) => i.count),
                        fill: true,
                        borderWidth: 1,
                        borderColor: 'rgb(0, 165, 252)',
                        backgroundColor: 'rgba(0, 165, 252,0.4)',
                    },
                    {
                        label: 'Objednané položky',
                        data: data.ordersItemsMonthly.map((i) => i.count),
                        fill: true,
                        borderWidth: 1,
                        borderColor: 'rgb(0, 175, 173)',
                        backgroundColor: 'rgba(0,175,173,.4)',
                    },
                ],
            }
        })
        const now = new Date()
        const periodStart = new Date()
        this.tasklistDateRange = [periodStart, now]
        periodStart.setDate(now.getDate() - 7)
        this.api.getTaskList({ from: periodStart.toISOString(), to: now.toISOString() }).subscribe((tasklist) => {
            this.tasklist = tasklist
        })
    }

    print(mode: 'small' | 'big') {}

    reloadTasklist() {
        if (this.tasklistDateRange.length === 2)
            this.api
                .getTaskList({
                    from: this.tasklistDateRange[0].toISOString(),
                    to: (this.tasklistDateRange[1] || new Date()).toISOString(),
                })
                .subscribe((tasklist) => {
                    this.tasklist = tasklist
                })
    }
}
